<template>
  <div>
    <template
      v-if="customServiceList.length === 0 && defaultServiceList.length === 0"
    >
      any
    </template>
    <template v-else>
      <div v-for="(customService, i) in customServices" :key="`customSv_${i}`">
        {{ customService.customServiceName || customService.serviceName }}
      </div>
      <div
        v-for="(defaultService, i) in defaultServices"
        :key="`defaultSv_${i}`"
      >
        {{ defaultService.serviceName }}
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { IntraPolicy } from "@/apis/IntranetfwPolicyApi";

/**
 * ポリシー用カスタムサービスの型
 * サービス名のプロパティ名がAPIによって異なるので、それぞれに合うよう型定義
 */
export type CustomServiceIntranet = IntraPolicy["customServiceList"][0] & {
  serviceName?: string;
};

/** ポリシー設定(イントラネットFW)のサービスを表示するコンポーネント */
export default defineComponent({
  name: "IntranetPolicyService",
  props: {
    /** デフォルトサービスリスト */
    defaultServiceList: {
      type: Array as PropType<IntraPolicy["serviceList"]>,
      required: true,
    },
    /** カスタムサービスリスト */
    customServiceList: {
      type: Array as PropType<CustomServiceIntranet[]>,
      required: true,
    },
  },
  computed: {
    /** 昇順ソート済みのデフォルトサービスリスト */
    defaultServices(): IntraPolicy["serviceList"] {
      return this.defaultServiceList.sortBy(["serviceName", "asc"]);
    },
    /** 昇順ソート済みのカスタムサービスリスト */
    customServices(): CustomServiceIntranet[] {
      return this.customServiceList.sortBy([
        (e) => e.customServiceName ?? e.serviceName,
        "asc",
      ]);
    },
  },
});
</script>
